import { createAction } from '@ngrx/store';

export const initUserProfileState = createAction('[UserProfile] Initialize');
